import classNames from 'classnames';

import { Wysiwyg as SVG } from '@jsmdg/yoshi/dist/components/Wysiwyg/Wysiwyg';
import { isBox } from '../../../shared/product-safeguards';
import { useProduct } from '../../hooks/useProduct';
import styles from './Nudge.module.scss';

const Nudge = (): JSX.Element | null => {
    const product = useProduct();
    const { productGroup, productNudge } = product;
    const isBoxWithProductGroup = isBox(product) && Boolean(productGroup?.length);

    if (!productNudge) {
        return null;
    }

    return (
        <>
            <div
                className={classNames(
                    'd-flex align-items-center py-0-5x px-1x mb-2x',
                    styles.nudgeContainer,
                    isBoxWithProductGroup && 'mt-2x',
                )}
            >
                {/* eslint-disable-next-line react/jsx-pascal-case */}
                <SVG
                    content={productNudge.icon}
                    key={productNudge.text}
                    className={classNames(styles.svgWrapper, 'd-flex mr-1x w-auto')}
                />
                <span className={styles.nudgeText}>{productNudge.text}</span>
            </div>
        </>
    );
};

export { Nudge };
